import React from 'react';
import styled from 'styled-components';
import Button from 'components/common/Button';
import { useNavigate } from 'react-router-dom';
import palette from 'lib/styles/palette';

const PaginationBlock = styled.div`
  width: 320px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  // padding-top: 60px;
  margin-bottom: 2rem;
  // border-top: 1px solid ${palette.gray[2]};
  // background: lightgray;
`;

const PageNumber = styled.div`
  margin: auto 0;  
`;

const Pagination = ({ pages }) => {
  const { total_pages, current_page, count, previous, next } = pages;
  const navigate = useNavigate();
  
  const handleGoPrevious = () => {
    const previousPage = pages.current_page - 1;
    navigate(`/postlist?page=${previousPage}`);
  };

  const handleGoNext = () => {
    const nextPage = pages.current_page + 1;
    navigate(`/postlist?page=${nextPage}`);
  };

  return (
    <div className="Pagination">
      <PaginationBlock>
        <Button disabled={previous === null} onClick={handleGoPrevious}>이전</Button>
        <PageNumber>{current_page}</PageNumber>
        <Button disabled={next === null} onClick={handleGoNext}>다음</Button>
      </PaginationBlock>
    </div>
  );
};

export default Pagination;